import React, { Component } from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import { checkUserType } from "../user-event";
import { AccountStatus } from "../account-status/account-status";

const dataFeild = [
  // {
  //   title: 'Số tài khoản',
  //   feildName: 'bank_account_number'
  // },
  {
    title: "Tên admin",
    feildName: "admin_name",
  },
  {
    title: "Số điện thoại",
    feildName: "mobile",
    validation: /^-{0,1}\d*\.{0,1}\d+$/,
  },
  {
    title: "Email",
    feildName: "email",
    validation: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  },
  {
    title: "Bộ phận",
    feildName: "department",
  },
  {
    title: "Trạng thái tài khoản",
    feildName: "accountStatus",
  },
  {
    title: "* Tên đăng nhập",
    feildName: "signinName",
  },
  {
    title: "Password",
    feildName: "password",
    validation: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()_\-:"'?/><.,|\\+= ]).{8,100}$/,
  },
];
export class AddNewAdmin extends Component {
  state = {
    country_code: "+84",
    mobile: "",
    iso2: "vn",
    showPassword: true,
    activeEye: false,
  };

  setPhone = (phone) => {
    let country_code = "+84";
    let iso2 = "vn";
    if (this.phone) {
      const { selectedCountry } = this.phone.state;
      country_code = selectedCountry.dialCode;
      iso2 = selectedCountry.iso2;
    }
    this.setState({
      country_code,
      mobile: phone.replace(country_code, "").replace("+", ""),
      iso2,
    });
  };

  showPassword = () => {
    this.setState({ showPassword: true });
  };

  hidePassword = () => {
    this.setState({ showPassword: false });
  };

  checkEditPass = (e) => {
    this.props.checkEditPass(e.target.value);
    this.setState({
      activeEye: true,
    });
  };

  render() {
    const { enterprise, editable, typeOption, setAccountStatus } = this.props;
    const { iso2, showPassword, activeEye } = this.state;
    return (
      <>
        {dataFeild.map((feild) => {
          return (
            <Form.Item
              className={
                (!enterprise && feild.feildName === "bank_account_number") ||
                (!enterprise && feild.feildName === "admin_name") ||
                (!enterprise && feild.feildName === "department")
                  ? "normalStyle add-admin"
                  : "requireStyle add-admin"
              }
              key={feild.feildName}
              label={`${feild.title}::`}
              name={feild.feildName}
              rules={
                feild.feildName === "mobile"
                  ? [
                      ({ getFieldValue }) => ({
                        validator(rule, v) {
                          if (!v) {
                            return Promise.reject(
                              `Vui lòng nhập Số điện thoại!`
                            );
                          }
                          if (v.length < 12) {
                            return Promise.reject(
                              `Số điện thoại không đúng định dạng!`
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]
                  : feild.feildName === "accountStatus"
                  ? []
                  : feild.feildName === "password"
                  ? [
                      ({ getFieldValue }) => ({
                        validator(rule, v) {
                          if (!v) {
                            return Promise.reject(`Vui lòng nhập Mật khẩu!`);
                          }
                          if (feild?.validation.test(v)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            "Mật khẩu không đúng định dạng!"
                          );
                        },
                      }),
                    ]
                  : feild.feildName === "bank_account_number" ||
                    feild.feildName === "admin_name" ||
                    feild.feildName === "department"
                  ? [checkUserType(feild.title)]
                  : feild.feildName === "email"
                  ? [
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (feild.feildName === "email") {
                            if (value) {
                              const listCheck = value.split("@");

                              if (
                                value.includes("..") ||
                                listCheck[0].startsWith(".") ||
                                listCheck[0].endsWith(".") ||
                                (listCheck.length > 1 &&
                                  listCheck[1].startsWith(".")) ||
                                (listCheck.length > 1 &&
                                  listCheck[1].endsWith("."))
                              ) {
                                return Promise.reject(
                                  "Vui lòng kiểm tra lại Email!"
                                );
                              }
                              if (value.length > 100) {
                                return Promise.reject(
                                  "Email vượt quá 100 ký tự!"
                                );
                              }
                              if (feild?.validation.test(value)) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                "Vui lòng kiểm tra lại Email!"
                              );
                            } else {
                              return Promise.reject(
                                "Vui lòng nhập địa chỉ Email!"
                              );
                            }
                          }
                        },
                      }),
                    ]
                  : [
                      {
                        required: true,
                        message: `Vui lòng nhập ${feild.title}!`,
                      },
                      {
                        type: feild?.typeRule,
                        message: `Vui lòng kiểm tra lại ${feild.title}!`,
                        pattern: feild?.validation,
                      },
                    ]
              }
            >
              {feild.feildName === "mobile" ? (
                <PhoneInput
                  disabled={!editable}
                  ref={(ref) => (this.phone = ref)}
                  autoFormat={false}
                  countryCodeEditable={false}
                  onChange={this.setPhone}
                  country={iso2}
                />
              ) : feild.feildName === "accountStatus" ? (
                <AccountStatus
                  setAccountStatus={setAccountStatus}
                  typeOption={typeOption}
                  editable={editable}
                />
              ) : (
                <Input
                  className={
                    feild.feildName === "password" && showPassword
                      ? "text-security"
                      : ""
                  }
                  onChange={
                    feild.feildName === "password" ? this.checkEditPass : null
                  }
                  type={feild?.type}
                  disabled={
                    feild.feildName === "signinName" ||
                    (feild.feildName === "password" &&
                      typeOption === "create_new") ||
                    (feild.feildName === "admin_name" && !enterprise) ||
                    !editable
                  }
                  placeholder={`${feild.title}`}
                />
              )}
            </Form.Item>
          );
        })}
        <span
          className={
            typeOption !== "edit" || !activeEye
              ? "block-click pass-visible"
              : "pass-visible"
          }
        >
          {!showPassword && <EyeOutlined onClick={this.showPassword} />}
          {showPassword && <EyeInvisibleOutlined onClick={this.hidePassword} />}
        </span>
      </>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 35,
  },
  contract_contained: {
    fontSize: "10px",
    color: "#f4bc2b",
    wordWrap: "break-all",
    whiteSpace: "pre-wrap",
    //lineHeight: '6px'
  },
  icon: {
    fontSize: "0.9em",
    marginRight: 3,
    color: "#f4bc2b",
  },
  mainTitle: {
    fontSize: "0.93em",
    color: "#000",
    fontWeight: "500",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    //lineHeight: '10px'
  },

  selectOptoption: {
    borderBottom: "0.3px solid #d9d9d9",
  },
};
